import { categoryUrl } from "./categoryDirectoryConfig";
import { communityUrl } from "./communityDirectoryConfig";

const firstText = (...values) => {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }

  return "";
};

const businessIdOf = (business) =>
  firstText(
    business?.id,
    business?.businessId,
    business?.business_id,
    business?.details?.canonical_id,
    business?.details_json?.canonical_id
  );

export const categoryBusinessUrl = (business) => {
  const businessId = businessIdOf(business);
  const category = firstText(
    business?.category,
    business?.business_type,
    business?.details?.category,
    business?.details_json?.category
  );

  const baseUrl = categoryUrl(category || "business");

  return businessId
    ? `${baseUrl}?business=${encodeURIComponent(businessId)}`
    : baseUrl;
};

export const communityBusinessUrl = (community, business) => {
  const businessId = businessIdOf(business);
  const baseUrl = communityUrl(community);

  return businessId
    ? `${baseUrl}?business=${encodeURIComponent(businessId)}`
    : baseUrl;
};

export const mapUrlForBusiness = (business) => {
  const directMapUrl = firstText(
    business?.mapUrl,
    business?.map_url,
    business?.details?.mapUrl,
    business?.details?.map_url,
    business?.details_json?.mapUrl,
    business?.details_json?.map_url
  );

  if (directMapUrl) {
    return directMapUrl;
  }

  const query = firstText(business?.address, business?.name);

  return query
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
    : "";
};
